/**
 * Shared constants across all platforms (Native, Web, etc.)
 */

/**
 * The identifier used for local data created when in Visitor Mode (unauthenticated).
 */
export const VISITOR_ID = "visitor";

/**
 * Standard HTTP Status Codes
 */
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;

/**
 * The slug for the default "Inbox" list.
 */
export const INBOX_SLUG = "inbox";

/**
 * A stable reference for an empty array to prevent unnecessary re-renders in hooks.
 */
export const EMPTY_ARRAY: readonly never[] = Object.freeze([]);

/**
 * Deep Linking Configuration
 */
export const APP_SCHEME = "mealplan";
export const APP_DOMAIN = "app.example.com";

/**
 * SOFT_DELETE_STANDARD — trash retention window (days). Server purge
 * (`TRASH_PURGE_DAYS`, default 30) permanently deletes
 * soft-deleted recipes whose `deleted_at` exceeds this threshold and records
 * `purged` in `activity` with snapshot. Client uses it ONLY for the informational
 * "will be deleted in Y days" countdown in trash view; the source of
 * truth for purge is server env (if set to 0 there purge is
 * disabled, but default matches this constant).
 */
export const TRASH_PURGE_DAYS = 30;
